import { ApiOptions } from '@csp/csp-common-model';
import { TenantConfigRestServiceV1 } from '@csp/dmdp-api-client';
import { toRestOptions } from '@csp/csp-fe-auth';
import { IcfConfig } from '../model/IcfConfig';
import { IcfConfigMapper } from '../mapper/IcfConfigMapper';

const fetchFormConfiguration = async (apiOptions?: ApiOptions): Promise<IcfConfig> => {
  const formConfig = await TenantConfigRestServiceV1.getFormConfiguration(toRestOptions(apiOptions));
  return IcfConfigMapper.from(formConfig);
};

export const IcfConfigService = {
  fetchFormConfiguration,
};
